import { useQuery, useQueries, UseQueryOptions } from 'react-query'
import { QueryKey } from 'config/constants/queryKey'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useCraftsman, useCraftsmanWeb3React } from 'hooks/useContract'
import { getCraftsmanContract, getCraftsmanV2Contract } from 'utils/contractHelpers'
import { SerializedFarmConfig } from 'config/constants/types'
import { isNilOrUndef } from 'utils/isNilOrUndef'

export const useVvsPerBlock = () => {
  const craftsmanContract = useCraftsman(true)
  return useQuery([QueryKey.CRAFTSMAN_VVS_PER_BLOCK], async () => {
    const res = await craftsmanContract.vvsPerBlock()
    return res
  })
}

export const useTotalAllocPoint = () => {
  const craftsmanContract = useCraftsman(true)
  return useQuery([QueryKey.CRAFTSMAN_TOTAL_ALLOC_POINT], async () => {
    const res = await craftsmanContract.totalAllocPoint()
    return res
  })
}

export const usePoolInfo = (addressId, queryOptions?: Partial<Pick<UseQueryOptions, 'enabled'>>) => {
  const craftsmanContract = useCraftsmanWeb3React()
  return useQuery(
    [QueryKey.CRAFTSMAN_POOL_INFO, addressId],
    async () => {
      if (isNilOrUndef(addressId)) return 0
      const res = await craftsmanContract.poolInfo(addressId)
      return res
    },
    {
      enabled: !!addressId && (queryOptions?.enabled ?? true),
      ...queryOptions,
    },
  )
}

export const useUserFarmLPInfo = (
  farm: SerializedFarmConfig,
  queryOptions?: Partial<Pick<UseQueryOptions, 'enabled'>>,
) => {
  const { library, account } = useActiveWeb3React()
  return useQuery(
    [QueryKey.CRAFTSMAN_USER_INFO, account, farm.pid],
    async () => {
      if (!account || isNilOrUndef(farm)) return 0
      const contract =
        farm.version === 2 ? getCraftsmanV2Contract(library.getSigner()) : getCraftsmanContract(library.getSigner())

      const res = await contract.userInfo(farm.pid, account)
      return res
    },
    {
      enabled: !!account && !!farm && (queryOptions?.enabled ?? true),
      ...queryOptions,
    },
  )
}

export const useUserFarmsInfo = (farmIds) => {
  const craftsmanContract = useCraftsman()
  const { account } = useActiveWeb3React()

  return useQueries(
    farmIds.map((farmId) => {
      return {
        queryKey: [QueryKey.CRAFTSMAN_USER_INFO, account, farmId],
        queryFn: async () => {
          if (!account || isNilOrUndef(farmId)) return 0
          const res = await craftsmanContract.userInfo(farmId, account)
          return {
            farmId,
            data: res,
          }
        },
      }
    }),
  )
}
